import { SidebarMenuItem, SidebarMenuSkeleton } from '@/components/sv/sidebar'

export const SidebarStatusIndicatorFallback = () => (
  <SidebarMenuItem>
    <SidebarMenuSkeleton showIcon />
  </SidebarMenuItem>
)
